function colType(dataType) {
    return dataType === "number" || dataType === "datetime" ? dataType : "string";
}
function indexType(dataType) {
    if (dataType === "datetime")
        return "timestamp";
    if (dataType === "number")
        return "number";
    return "string";
}
function normalizeCell(value, dataType) {
    if (value === null || value === undefined)
        return null;
    if (dataType === "number") {
        const n = typeof value === "number" ? value : parseFloat(String(value));
        return Number.isNaN(n) ? null : n;
    }
    if (dataType === "datetime") {
        return value instanceof Date ? value : String(value);
    }
    return String(value);
}
export function buildTableValue(columns, rows) {
    const indexDef = columns.find((c) => c.is_index);
    const dataColumns = columns.filter((c) => !c.is_index && c.code !== null);
    const schema = {
        indexColumn: indexDef
            ? {
                type: indexType(indexDef.data_type),
                name: indexDef.code ?? indexDef.name,
                required: false,
            }
            : undefined,
        columns: dataColumns.map((c) => ({
            name: c.code, // key by CODE
            type: colType(c.data_type),
            required: false,
            unit: c.unit ?? undefined,
        })),
    };
    const tableRows = rows.map((r) => {
        const data = {};
        for (const c of dataColumns) {
            data[c.code] = normalizeCell(r.cells[c.name], c.data_type);
        }
        const index = indexDef
            ? normalizeCell(r.cells[indexDef.name], indexDef.data_type)
            : null;
        return { index: index ?? undefined, data };
    });
    return {
        type: "table",
        value: {
            schema,
            rows: tableRows,
            indexColumn: schema.indexColumn?.name,
            metadata: {},
        },
    };
}
//# sourceMappingURL=materialize-table.js.map